import Controller from 'controllers/controller';
import Elements from 'tools/elements';

import jQuery from 'jquery';
import $ from 'jquery';

window.$ = window.jQuery = jQuery;

/**
 * @class CarouselsController - This controller finds carousels on the page, and initialises individual
 * CarouselController classes for each.
 */
class BookingController extends Controller {
    ready() {
        this.elements = new Elements;

        this.cacheElements();

        window.addEventListener('load', this.init);
    }

    init() {
        if (this.elements.get('book-now-links').length > 0) {
            this.loadBookATable();
        } else {
            console.log('Skipped loading book-a-table - there are no links to it on this page');
        }
    }

    injectBookATableScript() {
        console.log('injecting book-a-table script');

        let script = document.createElement('script');
        script.src = 'https://bda.bookatable.com/deploy/lbui.direct.min.js';
        script.async = true;

        document.body.appendChild(script);
    }

    loadBookATable() {
        this.injectBookATableScript();

        let tries = 0;

        this.loadInterval = setInterval(() => {
            if (++tries >= 40) {
                clearInterval(this.loadInterval);

                console.error(`Failed to load BookATableWidget after ${tries} attempts - one per 200 ms`)
            } else if (typeof $(document.body).lbuiDirect === 'function') {
                this.attachEvents();

                clearInterval(this.loadInterval);

                console.log('loaded lbuiDirect');
            }
        }, 200);
    }

    cacheElements() {
        this.elements.queryOne('iframe', '#book-a-table-iframe');
        this.elements.queryAll('book-now-links', '.link-type-bookatable_link');
    }

    attachEvents() {
        $(() => { $('.link-type-bookatable_link').lbuiDirect(
            {
                connectionid  :  "UK-RES-BOTANICA_433538:96317",
                style  :  {
                    useFlatDesign  :  true
                },
                modalWindow  :  {
                    enabled  :  true}
            });
        });

        this.elements.each('book-now-links', link => link.addEventListener('click', this.onLinkClick));
    }

    onBookNowModalClosed() {
        this.elements.iframe.src = 'about:blank';
    }

    onLinkClick(event) {
        event.preventDefault();
    }
}

export default BookingController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/booking.js